// extracted by mini-css-extract-plugin
export default {"root":"IconGlamping_root__Tp9Jt"};